import React from "react";
import ImageUploader from "./ImageUploader";

export default function PdfToolbar({
  activeTool,
  setActiveTool,
  onSignatureClick,
  handleImageUpload,
  saveFieldPositions,
  handleDownload,
  pdf,
  onToggleLeftSidebar,
  onToggleRightSidebar,
  showLeftSidebar,
  showRightSidebar,
}) {
  const toggleTool = (tool) => {
    setActiveTool((prev) => (prev === tool ? null : tool));
  };

  return (
    <div className="flex justify-between">
      <div className="flex items-center flex-row mt-1 py-2">
        <button
          data-tooltip-id="global-tooltip"
          data-tooltip-content={showLeftSidebar ? "Hide Pages" : "Show Pages"}
          onClick={onToggleLeftSidebar}
          className="px-2 hover:bg-dark-alt hover:text-tier-primary rounded lg:hidden flex items-center"
        >
          <span className="material-symbols-outlined text-base">
            {showLeftSidebar ? "left_panel_close" : "left_panel_open"}
          </span>
        </button>

        <button
          data-tooltip-id="global-tooltip"
          data-tooltip-content={
            activeTool === "text"
              ? "Click on canvas to add textbox"
              : "Enable Textbox Mode"
          }
          onClick={() => toggleTool("text")}
          className={`px-2 pb-0 rounded transition-colors ${
            activeTool === "text"
              ? "bg-tier-secondary text-tier-primary hover:bg-dark-alt"
              : "hover:bg-dark-alt hover:text-tier-primary"
          }`}
        >
          <span className="material-symbols-outlined text-base">
            text_fields
          </span>
        </button>

        <button
          data-tooltip-id="global-tooltip"
          data-tooltip-content="Click on canvas to add checkbox"
          onClick={() => toggleTool("checkbox")}
          className={`px-2 pb-0 rounded transition-colors ${
            activeTool === "checkbox"
              ? "bg-tier-secondary text-tier-primary hover:bg-dark-alt"
              : "hover:bg-dark-alt hover:text-tier-primary"
          }`}
        >
          <span className="material-symbols-outlined text-base">check_box</span>
        </button>

        <ImageUploader
          onUpload={(url) => {
            setActiveTool(null);
            handleImageUpload(url);
          }}
        >
          <button
            data-tooltip-id="global-tooltip"
            data-tooltip-content="Add Image"
            className="px-2 pb-0 hover:bg-dark-alt hover:text-tier-primary rounded"
          >
            <span className="material-symbols-outlined text-base">image</span>
          </button>
        </ImageUploader>

        <button
          data-tooltip-id="global-tooltip"
          data-tooltip-content={"Add Signature"}
          onClick={onSignatureClick}
          className={`
            px-2 pb-0 rounded transition-colors
            ${
              activeTool === "signature"
                ? "bg-tier-secondary text-tier-primary hover:bg-dark-alt"
                : "hover:bg-dark-alt hover:text-tier-primary"
            }`}
        >
          <span className="material-symbols-outlined text-base">signature</span>
        </button>

        <button
          data-tooltip-id="global-tooltip"
          data-tooltip-content={
            activeTool === "pan" ? "Disable Pan" : "Enable Pan"
          }
          onClick={() => toggleTool("pan")}
          className={`
            px-2 pb-0 rounded transition-colors
            ${
              activeTool === "pan"
                ? "bg-tier-secondary text-tier-primary hover:bg-dark-alt"
                : "hover:bg-dark-alt hover:text-tier-primary"
            }`}
        >
          <span className="material-symbols-outlined text-base">pan_tool</span>
        </button>
      </div>

      <div className="flex items-center gap-1 flex-row mt-1">
        <button
          data-tooltip-id="global-tooltip"
          data-tooltip-content="Save PDF"
          onClick={saveFieldPositions}
          className="px-2 bg-tier-secondary hover:bg-dark-alt hover:text-tier-primary text-xs flex items-center gap-1 rounded"
        >
          <span className="material-symbols-outlined text-base">save</span>
          <span>Save PDF</span>
        </button>

        <button
          data-tooltip-id="global-tooltip"
          data-tooltip-content="Download Pdf"
          onClick={handleDownload}
          className="px-2 bg-transparent border hover:bg-dark-alt hover:text-tier-primary text-xs flex items-center gap-1 rounded"
        >
          <span className="material-symbols-outlined text-base">download</span>
          <span>Download</span>
        </button>

        <button
          data-tooltip-id="global-tooltip"
          data-tooltip-content={
            showRightSidebar ? "Hide Field Manager" : "Show Field Manager"
          }
          onClick={onToggleRightSidebar}
          className="px-2 hover:bg-dark-alt hover:text-tier-primary rounded lg:hidden flex items-center"
        >
          <span className="material-symbols-outlined text-base">
            {showRightSidebar ? "right_panel_close" : "right_panel_open"}
          </span>
        </button>
      </div>
    </div>
  );
}
